export class QuantityControls {
    constructor(gformSejour) {
        this.gform = gformSejour;
        this.wrapper = gformSejour.formWrapper;
        this.init();
    }

    init() {
        const quantityInputs = this.wrapper.querySelectorAll('.ginput_quantity');
        quantityInputs.forEach(input => {
            if (input.closest('.gf-quantity-control')) return;
            this.wrapQuantityInput(input);
        });
    }

    wrapQuantityInput(input) {
        const parent = input.parentElement;
        const existingWrapper = parent.querySelector('.gf-quantity-wrapper');
        if (existingWrapper) return;

        const field = input.closest('.gfield');
        const isParticipantsField = field?.classList.contains('gf-sejour-participants');
        
        // Minimum 1 pour participants, 0 pour le reste
        const min = isParticipantsField ? 1 : (parseInt(input.getAttribute('min')) || 0);
        const max = parseInt(input.getAttribute('max')) || 99;

        const wrapper = document.createElement('div');
        wrapper.className = 'gf-quantity-wrapper';

        const control = document.createElement('div');
        control.className = 'gf-quantity-control';

        const minusBtn = document.createElement('button');
        minusBtn.type = 'button';
        minusBtn.className = 'gf-quantity-btn gf-quantity-btn--minus';
        minusBtn.textContent = '−';
        minusBtn.setAttribute('aria-label', 'Diminuer la quantité');

        const plusBtn = document.createElement('button');
        plusBtn.type = 'button';
        plusBtn.className = 'gf-quantity-btn gf-quantity-btn--plus';
        plusBtn.textContent = '+';
        plusBtn.setAttribute('aria-label', 'Augmenter la quantité');

        input.classList.add('gf-quantity-input');

        control.appendChild(minusBtn);
        control.appendChild(input.cloneNode(true));
        control.appendChild(plusBtn);

        const newInput = control.querySelector('input');
        
        // Déterminer la valeur initiale selon le champ
        // Participants (input_1.3) : minimum 1
        // Pensions et autres : 0 par défaut
        if (isParticipantsField) {
            // Participants : minimum 1
            if (!newInput.value || parseInt(newInput.value) < 1) {
                newInput.value = 1;
            }
        } else {
            // Pensions et transfert : 0 par défaut
            if (!newInput.value) {
                newInput.value = 0;
            }
        }

        wrapper.appendChild(control);

        const priceEl = parent.querySelector('.ginput_product_price');
        if (priceEl) {
            const priceWrapper = document.createElement('div');
            priceWrapper.className = 'gf-quantity-price';
            priceWrapper.textContent = priceEl.textContent;
            wrapper.appendChild(priceWrapper);
            priceEl.style.display = 'none';
        }

        input.replaceWith(wrapper);

        minusBtn.addEventListener('click', () => {
            const currentVal = parseInt(newInput.value) || 0;
            if (currentVal > min) {
                newInput.value = currentVal - 1;
                this.triggerChange(newInput);
            }
        });

        plusBtn.addEventListener('click', () => {
            const currentVal = parseInt(newInput.value) || 0;
            const effectiveMax = this.getEffectiveMax(newInput, max);
            if (currentVal < effectiveMax) {
                newInput.value = currentVal + 1;
                this.triggerChange(newInput);
            }
        });

        newInput.addEventListener('input', () => {
            this.validateInput(newInput, min, max);
        });

        newInput.addEventListener('blur', () => {
            this.validateInput(newInput, min, max);
        });

        this.updateButtonStates(newInput, minusBtn, plusBtn, min, max);

        newInput.addEventListener('change', () => {
            this.updateButtonStates(newInput, minusBtn, plusBtn, min, max);
            // Mettre à jour les boutons des champs liés (pensions adulte/enfant)
            this.updateLinkedPensionButtons();
        });
    }

    updateLinkedPensionButtons() {
        // Mettre à jour les boutons + des champs pensions quand l'un change
        const adultField = this.wrapper.querySelector('.gf-sejour-pension-adult');
        const childField = this.wrapper.querySelector('.gf-sejour-pension-child');
        const adultWrapper = adultField?.querySelector('.gf-quantity-control');
        const childWrapper = childField?.querySelector('.gf-quantity-control');

        if (adultWrapper) {
            const input = adultWrapper.querySelector('input');
            const plusBtn = adultWrapper.querySelector('.gf-quantity-btn--plus');
            const minusBtn = adultWrapper.querySelector('.gf-quantity-btn--minus');
            if (input && plusBtn && minusBtn) {
                const value = parseInt(input.value) || 0;
                const effectiveMax = this.getEffectiveMax(input, 99);
                minusBtn.disabled = value <= 0;
                plusBtn.disabled = value >= effectiveMax;
            }
        }

        if (childWrapper) {
            const input = childWrapper.querySelector('input');
            const plusBtn = childWrapper.querySelector('.gf-quantity-btn--plus');
            const minusBtn = childWrapper.querySelector('.gf-quantity-btn--minus');
            if (input && plusBtn && minusBtn) {
                const value = parseInt(input.value) || 0;
                const effectiveMax = this.getEffectiveMax(input, 99);
                minusBtn.disabled = value <= 0;
                plusBtn.disabled = value >= effectiveMax;
            }
        }
    }

    getEffectiveMax(input, defaultMax) {
        const field = input.closest('.gfield');
        const participants = this.gform.state.participants;

        // Pour les pensions adulte et enfant : la somme des deux ne doit pas dépasser le nombre de participants
        const isPensionAdult = field?.classList.contains('gf-sejour-pension-adult');
        const isPensionChild = field?.classList.contains('gf-sejour-pension-child');
        
        if (isPensionAdult || isPensionChild) {
            const adultField = this.wrapper.querySelector('.gf-sejour-pension-adult');
            const childField = this.wrapper.querySelector('.gf-sejour-pension-child');
            const adultInput = adultField?.querySelector('.ginput_quantity');
            const childInput = childField?.querySelector('.ginput_quantity');

            const adultValue = adultInput ? parseInt(adultInput.value) || 0 : 0;
            const childValue = childInput ? parseInt(childInput.value) || 0 : 0;

            // Si c'est le champ adulte, le max = participants - enfants
            if (isPensionAdult) {
                return Math.max(0, participants - childValue);
            }
            // Si c'est le champ enfant, le max = participants - adultes
            if (isPensionChild) {
                return Math.max(0, participants - adultValue);
            }
        }

        // Pour le transfert : limité au nombre de participants
        if (field?.classList.contains('gf-sejour-transfer')) {
            return participants;
        }

        return defaultMax;
    }

    validateInput(input, min, max) {
        let value = parseInt(input.value) || min;
        const effectiveMax = this.getEffectiveMax(input, max);

        if (value < min) value = min;
        if (value > effectiveMax) value = effectiveMax;

        input.value = value;
    }

    updateButtonStates(input, minusBtn, plusBtn, min, max) {
        const value = parseInt(input.value) || 0;
        const effectiveMax = this.getEffectiveMax(input, max);

        minusBtn.disabled = value <= min;
        plusBtn.disabled = value >= effectiveMax;
    }

    triggerChange(input) {
        input.dispatchEvent(new Event('change', { bubbles: true }));
        input.dispatchEvent(new Event('input', { bubbles: true }));

        if (typeof gform !== 'undefined' && gform.doAction) {
            gform.doAction('gform_input_change', input, this.gform.formId, input.name);
        }
    }
}
